
import React from 'react';
import { ClientDocumentsTab } from './ClientDocumentsTab';

interface ClientRecordsTabProps {
  clientId: string;
}

export const ClientRecordsTab: React.FC<ClientRecordsTabProps> = ({ clientId }) => {
  return <ClientDocumentsTab clientId={clientId} />;
};
